import { TFieldConfig, TFormField } from "../../types/common";
import dayjs from "dayjs";
import {
  beautify,
  prepareAttachmentsPost,
  returnArray,
  returnObject,
} from "../../utils/helpers";
import SelectInput from "./SelectInput";
import { DateInput } from "./DateInput";
import { Wrapper } from "../styled/Styled";
import ErrorSlate from "./ErrorSlate";
import {
  CButton,
  CFormInput,
  CFormTextarea,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import Assets from "./Assets";
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import FileInput from "./FileInput";
import PhoneInput from "react-phone-input-2";

const ModalForm = ({
  fields,
  sectionFields,
  error,
  form,
  // onChange,
  updateFormValue,
  updateFormValues,
  options,
  labelVariables,
  submitType,
  disabledDates,
  data,
  setError,
}: TFormField): any => {
  if (!Array.isArray(fields) && !Array.isArray(sectionFields)) return null;

  useEffect(() => {
    if (data) {
      updateFormValues({
        data: data,
      });
    }
  }, []);

  const actualFields = (fields: TFieldConfig[]) => {
    return fields.map((item, idx) => {
      const {
        type,
        placeholder,
        field_name,
        label = beautify(field_name),
        labelType,
        props,
        options_name,
        options_data,
        multiple,
        visible = true,
      } = item;

      if (!visible) return;

      function getPlaceholder() {
        return placeholder || `Enter ${label}`;
      }

      if (type === "select") {
        return (
          <Wrapper key={idx}>
            {label ? (
              <p className="capitalize font12 mb-1">
                {label} <RequiredIndicator required={props?.required} />
              </p>
            ) : null}

            {error && error?.data?.[field_name] && (
              <ErrorSlate message={error?.data?.[field_name]} />
            )}

            <SelectInput
              options={(options_name && options
                ? returnArray(options[options_name])
                : options_data
                  ? options_data
                  : []
              ).map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(value, obj: any) => {
                if (updateFormValues) {
                  var name: any = `${field_name}-name`;
                  updateFormValues({
                    data: form?.data
                      ? {
                          ...form?.data,
                          [field_name]: value,
                          [name]: obj?.label,
                        }
                      : { [field_name]: value, [name]: obj?.label },
                  });
                }
              }}
              value={
                isNaN(form[field_name as keyof typeof field_name])
                  ? form[field_name as keyof typeof field_name]
                  : form[field_name as keyof typeof field_name]
              }
              label={label}
              name={field_name}
              error={error}
              multiple={props?.multiple}
              {...props}
            />
          </Wrapper>
        );
      }

      if (type === "tel") {
        const [phone, setPhone] = useState(form?.data?.[field_name] || "");

        const handlePhoneOnChange = (value) => {
          setPhone(value);
          if (value.length < 12) {
            setError &&
              setError({
                ...(error && typeof error === "object" ? error : {}),
                data: {
                  ...(error?.data && typeof error.data === "object"
                    ? error?.data
                    : {}),
                  [field_name]: "Phone number must be at least 9 digits.",
                },
              });
          } else {
            const updatedError = { ...error };
            if (updatedError.data && updatedError.data[field_name]) {
              delete updatedError.data[field_name];
            }
            setError && setError(updatedError);
          }

          if (updateFormValues) {
            updateFormValues({
              data: form?.data
                ? { ...form?.data, [field_name]: value }
                : { [field_name]: value },
            });
          }
        };

        useEffect(() => {
          setPhone(form?.data?.[field_name] || "");
        }, [form?.data?.[field_name]]);
        return (
          <Wrapper key={idx}>
            {label ? (
              <p className="capitalize font12 mb-1">
                {label} <RequiredIndicator required={props?.required} />
              </p>
            ) : null}
            {error && error?.data?.[field_name] && (
              <ErrorSlate message={error?.data?.[field_name]} />
            )}
            <div id={field_name}>
              <PhoneInput
                country={"ug"}
                specialLabel={""}
                value={phone}
                onChange={handlePhoneOnChange}
                placeholder="Enter phone number"
                enableSearch={true}
                containerStyle={{ width: "100%" }}
                inputClass="phone-input-custom"
                dropdownStyle={{
                  borderRadius: "8px",
                  borderColor: "#ccc",
                  boxShadow:
                    "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
                }}
              />
            </div>
          </Wrapper>
        );
      }

      if (type === "date") {
        return (
          <Wrapper key={idx}>
            {label ? (
              <p className="capitalize font12 mb-1">
                {labelType === "variable" ? labelVariables?.[label] : label}{" "}
                <RequiredIndicator required={props?.required} />
              </p>
            ) : null}
            {error && error[field_name] && (
              <ErrorSlate message={error[field_name]} />
            )}
            <DateInput
              size="small"
              fullWidth
              type={type}
              id={field_name}
              name={field_name}
              placeholder={getPlaceholder()}
              value={
                form[field_name as keyof typeof field_name]
                  ? dayjs(form[field_name as keyof typeof field_name])
                  : null
              }
              onChange={(value) => {
                if (updateFormValue)
                  updateFormValue(
                    field_name,
                    value?.format(props?.format || "YYYY-MM-DD"),
                  );
              }}
              format="MM-DD-YYYY"
              // Pass the new props
              minDate={props?.minDate}
              maxDate={props?.maxDate}
              disablePast={props?.disablePast}
              disableFuture={props?.disableFuture}
              {...props}
              disabledDate={disabledDates ? disabledDates[field_name] : null}
            />
          </Wrapper>
        );
      }

      if (type === "radio") {
        return (
          <Wrapper key={idx}>
            {label ? (
              <p
                className="capitalize font12 mb-1"
                style={{ display: "inline-block", width: "80%" }}
              >
                {label} <RequiredIndicator required={props?.required} />
              </p>
            ) : null}
            {error && error?.data?.[field_name] && (
              <ErrorSlate message={error?.data?.[field_name]} />
            )}
            <div
              className="form-check"
              style={{ display: "inline-block", width: "20%" }}
            >
              {(options_name && options
                ? returnArray(options[options_name])
                : []
              ).map((item, idx) => {
                return (
                  <div key={idx} className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field_name}
                      id={item.id}
                      value={item.id}
                      checked={form[field_name] === item.id}
                      onChange={(event) => {
                        if (updateFormValues)
                          updateFormValues({
                            data: form?.data
                              ? {
                                  ...form?.data,
                                  [field_name]: event.target.value,
                                }
                              : { [field_name]: event.target.value },
                          });
                      }}
                    />
                    <label className="form-check-label" htmlFor={item.id}>
                      {item.name}
                    </label>
                  </div>
                );
              })}
            </div>
          </Wrapper>
        );
      }

      if (type === "file") {
        const customUpdateFormValue = (field: string, value: any) => {
          let updateData: any = { [field]: value };
          if (props?.nested_attachment) {
            updateData = prepareAttachmentsPost([value], "attachments");
          }
          if (updateFormValues) {
            updateFormValues({
              data: form?.data
                ? {
                    ...form?.data,
                    ...updateData,
                  }
                : updateData,
            });
          }
        };
        return (
          <Wrapper key={idx}>
            {label ? (
              <p className="capitalize font12 mb-1">
                {label} <RequiredIndicator required={props?.required} />
              </p>
            ) : null}
            <FileInput
              size="sm"
              updateFormValue={customUpdateFormValue}
              field_name={field_name}
              placeholder={getPlaceholder()}
              nested_attachment={props?.nested_attachment}
              // value={form?.[field_name] || value}
              {...props}
            />
          </Wrapper>
        );
      }

      return (
        <Wrapper key={idx}>
          {label ? (
            <p className="capitalize font12 mb-1">
              {label} <RequiredIndicator required={props?.required} />
            </p>
          ) : null}

          {multiple && submitType === "create" ? (
            (form?.[field_name] || [""]).map((value: any, idx: number) => {
              const handleActions = (action: "delete" | "add", idx: number) => {
                if (action === "delete") {
                  if (updateFormValue)
                    updateFormValue(
                      field_name,
                      form[field_name].filter(
                        (_item: any, id: number) => id !== idx,
                      ),
                    );
                }

                if (action === "add") {
                  if (updateFormValue)
                    updateFormValue(field_name, [
                      ...(form?.[field_name] || [""]),
                      "",
                    ]);
                }
              };
              return (
                <CInputGroup key={value}>
                  <CInputGroupText>
                    <CIcon icon={Assets[type || "text"]} />
                  </CInputGroupText>
                  {type === "textarea" ? (
                    <CFormTextarea
                      onChange={(event) => {
                        if (updateFormValues)
                          updateFormValues({
                            data: form?.data
                              ? {
                                  ...form?.data,
                                  [field_name]: event.target.value,
                                }
                              : { [field_name]: event.target.value },
                          });
                      }}
                      placeholder={getPlaceholder()}
                      value={value}
                      {...props}
                    />
                  ) : (
                    <CFormInput
                      size="sm"
                      onChange={(event) => {
                        if (updateFormValues)
                          updateFormValues({
                            data: form?.data
                              ? {
                                  ...form?.data,
                                  [field_name]: event.target.value,
                                }
                              : { [field_name]: event.target.value },
                          });
                      }}
                      placeholder={getPlaceholder()}
                      value={value}
                      {...props}
                    />
                  )}

                  {(form?.[field_name] || [""]).length > 1 ? (
                    <CButton onClick={() => handleActions("delete", idx)}>
                      <CIcon icon={Assets["delete"]} />
                    </CButton>
                  ) : null}
                  {idx + 1 === (form?.[field_name] || [""]).length ? (
                    <CButton onClick={() => handleActions("add", idx)}>
                      <CIcon icon={Assets["plus"]} />
                    </CButton>
                  ) : null}
                </CInputGroup>
              );
            })
          ) : (
            <CInputGroup>
              <CInputGroupText>
                <CIcon icon={Assets[type || "text"]} />
              </CInputGroupText>
              {type === "textarea" ? (
                <CFormTextarea
                  size="sm"
                  onChange={(event) => {
                    if (updateFormValues)
                      updateFormValues({
                        data: form?.data
                          ? { ...form?.data, [field_name]: event.target.value }
                          : { [field_name]: event.target.value },
                      });
                  }}
                  name={field_name}
                  placeholder={getPlaceholder()}
                  value={form?.data?.[field_name]}
                  type={type || "text"}
                  {...props}
                />
              ) : (
                <CFormInput
                  size="sm"
                  onChange={(event) => {
                    if (updateFormValues)
                      updateFormValues({
                        data: form?.data
                          ? { ...form?.data, [field_name]: event.target.value }
                          : { [field_name]: event.target.value },
                      });
                  }}
                  name={field_name}
                  placeholder={getPlaceholder()}
                  value={form?.data?.[field_name]}
                  type={type || "text"}
                  {...props}
                />
              )}
            </CInputGroup>
          )}
          {error && error?.data?.[field_name] && (
            <ErrorSlate message={error?.data?.[field_name]} />
          )}
        </Wrapper>
      );
    });
  };

  const renderFields = (fields: TFieldConfig[]) => {
    return (
      <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
        {fields.map((field, index) => {
          const isWide = field.props?.wide;
          const isNewLine = field.props?.newLine;
          const isSmall = field.props?.smallWidth;
          const isVisible = field.visible;
          if (isVisible == false) return;
          return (
            <React.Fragment key={index}>
              {isNewLine && <div style={{ flexBasis: "100%", height: 0 }} />}
              <div
                className={
                  isWide
                    ? "col-sm-12"
                    : isSmall
                      ? "col-sm-4"
                      : "col-lg-6 col-md-6 col-sm-12"
                }
                style={{
                  marginBottom: "1rem",
                  flexGrow: isWide ? 1 : 0,
                  ...returnObject(isWide, {
                    flexBasis: "100%",
                    maxWidth: "100%",
                  }),
                }}
              >
                {actualFields([field])}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  if (sectionFields) {
    return sectionFields.map((item, idx) => {
      return (
        <div key={idx}>
          <h4 className="pt-3 lead-900">{item.title}</h4>
          {renderFields(item.fields || [])}
          <Button className="btn-theme"> button</Button>
        </div>
      );
    });
  } else if (fields) {
    return renderFields(fields);
  }
};

export const RequiredIndicator = ({ required }: { required?: boolean }) =>
  required ? <span className="text-danger">*</span> : null;

export default ModalForm;
